import { type FormInstance, Tabs } from "antd";
import { useIntl } from "react-intl";
import { MiscTab } from "~pages/Persons/PersonProfile/components/PersonProfileFormTabs/MiscTab.tsx";
import { PersonalTab } from "~pages/Persons/PersonProfile/components/PersonProfileFormTabs/PersonalTab.tsx";
import { SocialTab } from "~pages/Persons/PersonProfile/components/PersonProfileFormTabs/SocialTab.tsx";
import type { UpsertPersonForm } from "~pages/Persons/PersonProfile/types/upsertPersonForm.ts";
import type { Person } from "~types/person.ts";

type Props = {
  data?: Person;
  personId?: string;
  isLoading: boolean;
  form: FormInstance<UpsertPersonForm>;
};

export const PersonProfileFormTabs = ({ data, personId, isLoading, form }: Props) => {
  const { formatMessage } = useIntl();

  const tabs = [
    {
      key: "personal",
      label: formatMessage({ id: "personal" }),
      children: <PersonalTab isLoading={isLoading} form={form} />,
    },
    {
      key: "social",
      label: formatMessage({ id: "social" }),
      children: <SocialTab isLoading={isLoading} />,
    },
    {
      key: "misc",
      label: formatMessage({ id: "misc" }),
      children: <MiscTab data={data} personId={personId} />,
    },
  ];

  return (
    <div className="card-container tabs-wrap person-profile-tabs">
      <Tabs tabBarGutter={10} defaultActiveKey={"personal"} items={tabs} />
    </div>
  );
};
